import { Injectable } from '@angular/core';
import { IsApiService } from 'projects/is-ui-kit/src/lib/core/is-api/is-api.service';
import { SettingsConstants, SettingsService, UrlFormatterOptions } from 'projects/is-ui-kit/src/lib/core/settings/settings.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GenericApiService {

  constructor(
    private _isApi: IsApiService,
    private _settings: SettingsService,
    private _http: HttpClient
  ) { }

  public getCustomers(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getCustomers',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }
  public getLicensesList(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getLicenses',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }
  public getModules(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getModules',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getChangeRequest(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getChangeRequest',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getAccountsList(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getAccountsList',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getChangeRequestDetail(callbackFn: (error: Error, data: any) => void, id: number, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getChangeRequestDetail',
      method: 'get',
      queryParams,
      params: { id: id }
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getAccountDetail(callbackFn: (error: Error, data: any) => void, id: number, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getAccountDetail',
      method: 'get',
      queryParams,
      params: { id: id }
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getChangeRequestStatus(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getChangeRequestStatus',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getPossibleChangeRequestTransitions(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getPossibleTransitions',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getMakeChangeRequestTransitions(callbackFn: (error: Error, data: any) => void, label: string, bodyRequest: any = ''): void {
    const request = this._isApi.request({
      api: 'getMakeTransitions',
      method: 'put',
      params: { label },
      bodyRequest
    });
    this._isApi.subscribe(request, callbackFn);
  }


  public setUserPreferences(callbackFn: (error: Error, data: any) => void, bodyRequest: {}): void {
    const request = this._isApi.request({
      api: 'setUserPreferences',
      method: 'post',
      bodyRequest,
      params: {
        id: SettingsConstants.LOGGEDUSER?.id
      }
    });
    this._isApi.subscribe(request, (err: Error, data: any) => {
      callbackFn(err, data);

      // update user preferences
      this.getUserPreferences();
    });
  }

  public getInstallationsTypes(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getInstallationsTypes',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getSitesCode(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getSitesCode',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getCustomersCode(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getCustomersCode',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }
  public getCustomersCodePublic(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getCustomersCodePublic',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public getLicenseModuleTypes(callbackFn: (error: Error, data: any) => void, queryParams: any = ''): void {
    const request = this._isApi.request({
      api: 'getLicenseModuleTypes',
      method: 'get',
      queryParams
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public createLicense(callbackFn: (error: Error, data: any) => void, bodyRequest: any): void {
    const request = this._isApi.request({
      api: 'createLicense',
      method: 'post',
      bodyRequest
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public createChangeRequest(callbackFn: (error: Error, data: any) => void, bodyRequest: any): void {
    const request = this._isApi.request({
      api: 'createChangeRequest',
      method: 'post',
      bodyRequest
    });
    this._isApi.subscribe(request, callbackFn);
  }
  public putEditLicense(callbackFn: (error: Error, data: any) => void, id: number, bodyRequest: any): void {
    const request = this._isApi.request({
      api: 'editLicense',
      method: 'put',
      params: { id: id },
      bodyRequest
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public createUser(callbackFn: (error: Error, data: any) => void, bodyRequest: any): void {
    const request = this._isApi.request({
      api: 'createUser',
      method: 'post',
      bodyRequest
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public editUser(callbackFn: (error: Error, data: any) => void, id: number, bodyRequest: any): void {
    const request = this._isApi.request({
      api: 'editAccount',
      method: 'post',
      bodyRequest,
      params: { id: id }
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public resetPasswordRequest(callbackFn: (error: Error, data: any) => void, bodyRequest: any): void {
    const request = this._isApi.request({
      api: 'resetPasswordRequest',
      method: 'post',
      bodyRequest
    });
    this._isApi.subscribe(request, callbackFn);
  }

  public resetPasswordConfirm(callbackFn: (error: Error, data: any) => void, bodyRequest: any): void {
    const request = this._isApi.request({
      api: 'resetPasswordConfirm',
      method: 'post',
      bodyRequest
    });
    this._isApi.subscribe(request, callbackFn);
  }


  public async getUserPreferences(): Promise<any> {
    const optionsForCall: UrlFormatterOptions = {
      url: this._settings.getApi('getUserPreferences'),
      params: {
        id: SettingsConstants.LOGGEDUSER?.id
      }
    };
    const preferences = await this._http.get<any>(this._settings.formatUrl(optionsForCall)).toPromise();
    SettingsConstants.USERPREFERENCES = preferences;
  }

}
